<template>
  <pie-chart
    v-if="genderChart"
    key="genderChart"
    :chart-data="genderChart"
    :tooltips-callback-cfg="tooltipsCallbackCfg"
    :width="width"
    :height="height"
  ></pie-chart>
</template>
<script>
import PieChart from "@/components/Base/PieChart";
import { COLOR_OPTION_GENDER } from "@/helpers/color-chart-config";

export default {
  name: "gender-chart-admin",
  components: { PieChart },
  props: ["gender", "width", "height"],
  data() {
    return {
      tooltipsCallbackCfg: {
        title: {
          prefix: "Gender"
        },
        label: true,
        afterLabel: {
          subfix: "students"
        }
      }
    };
  },
  computed: {
    genderChart() {
      return this.generateGenderChart(this.gender);
    }
  },
  methods: {
    generateGenderChart(dataGender) {
      if (!dataGender) return null;

      const { label, data } = dataGender;
      return {
        labels: label,
        datasets: [
          {
            data: data,
            backgroundColor: label.map(label => COLOR_OPTION_GENDER[label]),
            borderWidth: 1
          }
        ]
      };
    }
  }
};
</script>
